var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm.canEdit && _vm.step !== 0
            ? _c(
                "a",
                {
                  staticClass: "edit",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.edit("room")
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(_vm.tc("booking.edit")) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "section-label capitalize" }, [
            _vm._v("\n      " + _vm._s(_vm.roomLabel) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "overview-item" }, [
            _c("div", { staticClass: "item-label bold-item" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.room.sitecoreContent.room.title) +
                  " | " +
                  _vm._s(_vm.room.sitecoreContent.bed.title) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-value section-label" }, [
              _vm._v("\n        " + _vm._s(_vm.roomGuestsSummary) + "\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section-label" }, [
            _vm._v("\n      " + _vm._s(_vm.tc("booking.rate")) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "overview-item rate" }, [
            _c("div", { staticClass: "item-label bold-item" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.room.sitecoreContent.rate.title || "Selected Rate"
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-value" }, [
              _c("div", [_vm._v(_vm._s(_vm.avgPerNight))]),
              _vm._v(" "),
              _c("div", { staticClass: "section-label capitalize" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.tc("booking.avgPerNight")) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.userId && _vm.roomEnhancements.length
            ? _c("room-enhancements-overview", {
                attrs: { "room-index": _vm.roomIndex },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nightly-rates" },
            [
              _c(
                "see-details",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "details",
                      fn: function () {
                        return [
                          _c("overview-nightly-rates", {
                            attrs: { "nightly-rates": _vm.room.nightlyRates },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("div", { staticClass: "overview-item" }, [
                    _c("div", { staticClass: "item-label bold-item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.room.nightlyRates.length) +
                          " " +
                          _vm._s(
                            _vm.room.nightlyRates.length > 1
                              ? _vm.tc("noums.nightPlural")
                              : _vm.tc("noums.nightSingular")
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item-value bold-item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.getDisplayPrice({ price: _vm.totalPerNight })
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.roomAddOns.length
        ? _c("AddOnsOverview", {
            attrs: { "add-ons": _vm.roomAddOns, "can-edit": _vm.canEdit },
            on: {
              edit: function ($event) {
                return _vm.edit("add-on")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }